// props.memberRequirement.requiredDocuments, props.itemIndex
export const handleLoadCommenrcialInsurance = (memberRequirement, requiredDocuments, itemIndex, setInsuranceDetails, setCommercialInsurance,setUserUploadedInsurancePic,  insurancePic) => {
    setCommercialInsurance(insurancePic);
    for (let requiredItems of requiredDocuments[itemIndex].requiredItems) {
        if ( requiredItems.value !== "" && requiredItems.itemName === "insuranceCompany") {
          setInsuranceDetails((insuranceDetails) => ({
            ...insuranceDetails,
            insuranceCompany: requiredItems.value,
          }));
        }
        
        if ( requiredItems.value !== "" && requiredItems.itemName === "insuranceExpiryDate") {
          setInsuranceDetails((insuranceDetails) => ({
            ...insuranceDetails,
            insuranceExpiryDate: requiredItems.value,
          }));
        }
        if ( requiredItems.value !== "" && requiredItems.itemName === "carInsurance") {
            setCommercialInsurance(requiredItems.url);
          setUserUploadedInsurancePic(true);
        }
        
      }
}